// deps
import React, { memo } from "react";
import { useTheme } from "styled-components";

// internal deps
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { default as ArrowBack } from "@swiggy-private/dls-web-icons/dist/web/generic/arrowBack/24";
import { PAYMENT_CART_HEADER } from "@swiggy-private/cart-test-ids";
import { format } from "@swiggy-private/core-ui";

// styles
import {
    HeaderGridWrapper,
    GridItem,
    BackIconWrapper,
    RestaurantInfoWrapper,
    StyledText,
    SubHeader,
    HelpIconWrapper,
} from "./styles";

//constants
import { PAYING } from "@dineout-cart-ui/constants/index";

interface HeaderWrapperProps {
    isStickHeader?: boolean;
    restaurantName?: string;
    restaurantLocation?: string;
    headerTheme?: string;
    helpIconImage: string;
    goBack: () => void;
    onHelpClick: () => void;
}

const HeaderWrapper: React.FC<HeaderWrapperProps> = ({
    isStickHeader,
    restaurantName = "",
    restaurantLocation,
    helpIconImage,
    headerTheme,
    goBack,
    onHelpClick,
}) => {
    const theme = useTheme();

    return (
        <HeaderGridWrapper isStickHeader={Boolean(isStickHeader)}>
            <GridItem>
                <BackIconWrapper>
                    <GenericIcon
                        fillColor={isStickHeader ? "text_Highest_Emphasis" : "background_Primary"}
                        strokeColor={isStickHeader ? "text_Highest_Emphasis" : "background_Primary"}
                        onClick={goBack}
                        Icon={ArrowBack}
                    />
                </BackIconWrapper>
            </GridItem>
            <GridItem>
                <RestaurantInfoWrapper>
                    <StyledText
                        variant="V2.body1.neutral.bold"
                        color={headerTheme === theme.colorMode ? "text_Highest_Emphasis" : "background_Primary"}
                        data-testid={PAYMENT_CART_HEADER.HEADING}
                        maxLines={1}
                    >
                        {format(PAYING, restaurantName)}
                    </StyledText>
                    <SubHeader
                        variant="V2.body3.neutral.regular"
                        color={headerTheme === theme.colorMode ? "text_Med_Emphasis" : "text_inverse_Med_Emphasis"}
                        maxLines={1}
                        data-testid={PAYMENT_CART_HEADER.SUB_HEADING}
                    >
                        {restaurantLocation}
                    </SubHeader>
                </RestaurantInfoWrapper>
            </GridItem>
            <GridItem>
                <HelpIconWrapper onClick={onHelpClick}>
                    <Image src={helpIconImage} />
                </HelpIconWrapper>
            </GridItem>
        </HeaderGridWrapper>
    );
};

export default memo(HeaderWrapper);
